import { render, staticRenderFns } from "./ButtonPayBike.vue?vue&type=template&id=5b8caa4b"
import script from "./ButtonPayBike.vue?vue&type=script&lang=js"
export * from "./ButtonPayBike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports